export const IS_LOCAL =
  process.env.NODE_ENV === 'development' || process.env.ENVIRONMENT === 'dev';

export const MULTI_BRANCH_SLUG = `${
  process.env.NEXT_PUBLIC_MULTI_BRANCH_SLUG || ''
}`;
